import { createSlice } from '@reduxjs/toolkit';
import { fetchSettings, createSetting, updateSetting, deleteSetting } from '../thunks/settingsThunks.js';

const initialState = {
    loading: false,
    settings: [],
    error: null,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(
                (action) =>
                    [
                        fetchSettings.pending.type,
                        createSetting.pending.type,
                        updateSetting.pending.type,
                        deleteSetting.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchSettings.rejected.type,
                        createSetting.rejected.type,
                        updateSetting.rejected.type,
                        deleteSetting.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload || action.error?.message;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchSettings.fulfilled.type,
                        createSetting.fulfilled.type,
                        updateSetting.fulfilled.type,
                        deleteSetting.fulfilled.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.settings = action.payload;
                    state.error = null;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default settingsSlice.reducer;
